import { Pipe, PipeTransform } from '@angular/core';

import { AssetState, getState } from '@data';

@Pipe({
  name: 'assetState',
})
export class AssetStatePipe implements PipeTransform {
  transform(state: AssetState): string {
    return getState(state);
  }
}
